module.exports = __webpack_public_path__ + "img/KW.4676e216.svg";